
window.theme.block('slider-gallery', el => {
    const sliderElement = el.querySelector('.js-slider-gallery');

    if (sliderElement) {
        new window.theme.packages.swiper(sliderElement, {
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 600,
            navigation: {
                prevEl: el.querySelector('.js-prev'),
                nextEl: el.querySelector('.js-next')
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
            }
        });
    }
});
